const TOKEN_QUERY_KEYS = [
  'token',
  'booking_token',
  'bookingToken',
  'action_token',
  'actionToken',
  'booking_action_token',
  'bookingActionToken',
  'invite_token',
  'inviteToken',
];

const ACTION_QUERY_KEYS = ['action', 'booking_action', 'bookingAction', 'decision'];
const SLOT_QUERY_KEYS = ['slot_value', 'slotValue', 'selected_slot', 'selectedSlot', 'slot'];

const RESERVED_PATH_SEGMENTS = new Set([
  'interview-booking',
  'manage',
  'reschedule',
  'confirm',
  'accept',
  'next-slot',
  'next_slot',
]);

const ACTION_ALIASES = {
  accept: 'accept',
  accepted: 'accept',
  approve: 'accept',
  approved: 'accept',
  confirm: 'accept',
  confirmed: 'accept',
  yes: 'accept',
  decline: 'decline',
  declined: 'decline',
  reschedule: 'reschedule',
  rescheduled: 'reschedule',
  reshedule: 'reschedule',
  're-schedule': 'reschedule',
  re_schedule: 'reschedule',
  next: 'next_slot',
  'next-slot': 'next_slot',
  nextslot: 'next_slot',
  next_slot: 'next_slot',
};

function readFirstSearchParam(searchParams, keys) {
  if (!searchParams || typeof searchParams.get !== 'function') return '';
  for (const key of keys) {
    const value = String(searchParams.get(key) || '').trim();
    if (value) return value;
  }
  return '';
}

function extractHashSearchParams(hashValue) {
  const raw = String(hashValue || '').trim();
  if (!raw) return new URLSearchParams();

  if (raw.includes('?')) {
    const query = raw.slice(raw.indexOf('?') + 1);
    return new URLSearchParams(query);
  }

  const hashBody = raw.startsWith('#') ? raw.slice(1) : raw;
  if (hashBody.includes('=')) {
    return new URLSearchParams(hashBody);
  }

  return new URLSearchParams();
}

function normalizeActionValue(value) {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return '';
  return ACTION_ALIASES[raw] || ACTION_ALIASES[raw.replace(/\s+/g, '_')] || '';
}

function readTokenFromPath(pathname, params = {}) {
  const directParamCandidates = [params.token, params.bookingToken, params.actionToken];
  for (const candidate of directParamCandidates) {
    const value = String(candidate || '').trim();
    if (value) return value;
  }

  const segments = String(pathname || '')
    .split('/')
    .map((segment) => {
      try {
        return decodeURIComponent(segment);
      } catch {
        return segment;
      }
    })
    .map((segment) => String(segment || '').trim())
    .filter(Boolean);

  for (let index = segments.length - 1; index >= 0; index -= 1) {
    const segment = segments[index];
    if (!segment || RESERVED_PATH_SEGMENTS.has(segment.toLowerCase())) continue;
    return segment;
  }

  return '';
}

function readActionFromPath(pathname, params = {}) {
  const directParam = normalizeActionValue(params.action);
  if (directParam) return directParam;

  const segments = String(pathname || '')
    .split('/')
    .map((segment) => {
      try {
        return decodeURIComponent(segment);
      } catch {
        return segment;
      }
    })
    .map((segment) => String(segment || '').trim())
    .filter(Boolean);

  for (const segment of segments) {
    const normalized = normalizeActionValue(segment);
    if (normalized) return normalized;
  }

  return '';
}

export function resolveBookingActionToken({ searchParams, location, params } = {}) {
  const fromQuery = readFirstSearchParam(searchParams, TOKEN_QUERY_KEYS);
  if (fromQuery) return fromQuery;

  const fromHashQuery = readFirstSearchParam(
    extractHashSearchParams(location?.hash),
    TOKEN_QUERY_KEYS
  );
  if (fromHashQuery) return fromHashQuery;

  const fromPath = readTokenFromPath(location?.pathname, params);
  if (fromPath) return fromPath;

  if (typeof window !== 'undefined') {
    const fromWindow =
      window.__INTERVIEW_BOOKING_TOKEN__ ||
      window.__BOOKING_ACTION_TOKEN__ ||
      window.__BOOKING_TOKEN__;
    const normalized = String(fromWindow || '').trim();
    if (normalized) return normalized;
  }

  return '';
}

export function resolveBookingActionValue({ searchParams, location, params } = {}) {
  const fromQuery = normalizeActionValue(readFirstSearchParam(searchParams, ACTION_QUERY_KEYS));
  if (fromQuery) return fromQuery;

  const fromHashQuery = normalizeActionValue(
    readFirstSearchParam(extractHashSearchParams(location?.hash), ACTION_QUERY_KEYS)
  );
  if (fromHashQuery) return fromHashQuery;

  return readActionFromPath(location?.pathname, params);
}

export function resolveBookingSlotValue({ searchParams, location } = {}) {
  const fromQuery = readFirstSearchParam(searchParams, SLOT_QUERY_KEYS);
  if (fromQuery) return fromQuery;

  return readFirstSearchParam(extractHashSearchParams(location?.hash), SLOT_QUERY_KEYS);
}

